<template>
  <div>
    <div
      v-if="!loaded"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div
      v-if="loaded"
      class="content"
    >
      <h1 class="has-text-centered">
        Personal Information
      </h1>
      <hr>
      <div class="box">
        <form>
          <label class="label">Full Name</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="first"
                    class="input"
                    type="text"
                    placeholder="First"
                  >
                </p>
              </div>
            </div>
            <div class="column is-2">
              <div class="field">
                <p class="control">
                  <input
                    v-model="middle"
                    class="input"
                    type="text"
                    placeholder="Middle"
                  >
                </p>
              </div>
            </div>
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="last"
                    class="input"
                    type="text"
                    placeholder="Last"
                  >
                </p>
              </div>
            </div>
          </div>
          <hr>
          <label class="label">Poker Nickname</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="handle"
                    class="input"
                    type="text"
                    placeholder="Poker Nickname (optional)"
                  >
                </p>
              </div>
            </div>
          </div>
          <hr>
          <label class="label">Address</label>
          <hr>
          <div class="columns">
            <div class="column is-12">
              <div class="field">
                <p class="control">
                  <input
                    v-model="address"
                    class="input"
                    type="text"
                    placeholder="Full Address (optional)"
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="city"
                    class="input"
                    type="text"
                    placeholder="City"
                  >
                </p>
              </div>
            </div>
            <div class="column is-2">
              <div class="field">
                <p class="control">
                  <input
                    v-model="state"
                    class="input"
                    type="text"
                    placeholder="State"
                  >
                </p>
              </div>
            </div>
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="zip"
                    class="input"
                    type="text"
                    placeholder="ZIP"
                  >
                </p>
              </div>
            </div>
          </div>
          <hr>
          <label class="label"> Miscellaneous</label>
          <hr>
          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <p class="control">
                  <input
                    v-model="email"
                    class="input"
                    type="email"
                    placeholder="Email"
                  >
                </p>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <div class="field is-horizontal">
                  <div class="field-body">
                    <div class="field">
                      <p class="control">
                        <input
                          v-model="phone"
                          class="input"
                          type="text"
                          placeholder="Phone (optional)"
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12">
              <div class="control">
                <label class="checkbox">
                  <input
                    v-model="updates"
                    type="checkbox"
                  >
                  I would like to recieve email updates from AHL Poker
                </label>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12">
              <div class="field">
                <div class="field is-horizontal">
                  <div class="field-body">
                    <div class="field">
                      <p class="control">
                        <input
                          v-model="password"
                          class="input"
                          type="password"
                          placeholder="Password"
                        >
                      </p>
                    </div>
                    <div class="field">
                      <p class="control">
                        <input
                          v-model="confirm"
                          class="input"
                          type="password"
                          placeholder="Confirm Password"
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field">
                <div class="field is-horizontal">
                  <div class="field-body">
                    <div class=" ">
                      <label class="label">Region:</label>
                      <p class="button is-info">
                        {{ region }}
                      </p>
                    </div>
                    <div class="field">
                      <label
                        class="label"
                        style="color: transparent;"
                      >
                        Click here to set your region
                      </label>
                      <p class="control">
                        <button
                          class="button is-dark"
                          @click="setRegion()"
                        >
                          Click here to set your region
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <button
                    type="submit"
                    class="button is-info"
                    @click.prevent="updateProfile()"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'AccountEdit',
    metaInfo: {
      title: 'AHL Poker :: My Account'
    },
    components: {
    },
    props: ['user', 'token'],
    data () {
      return {
        region: '',
        first: '',
        middle: '',
        last: '',
        ahlid: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        handle: '',
        updates: true,
        email: '',
        password: '',
        confirm: '',
        loaded: false
      }
    },
    mounted () {
      if (this.$route.params.region) {
        this.region = this.$route.params.region
      }
      this.getUserDetails()
    },
    methods: {
      getUserDetails () {
        let url = `member/profile`
        this.$axios({
          method: 'POST',
          url: url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token
          }
        })
          .then((res) => {
            this.first = res.data[0].first
            this.middle = res.data[0].mi
            this.last = res.data[0].last
            this.address = res.data[0].address
            this.ahlid = res.data[0].ahlid
            this.city = res.data[0].city
            this.email = res.data[0].email
            this.handle = res.data[0].handle
            if (!this.region) {
              this.region = res.data[0].region
            }
            this.state = res.data[0].state
            this.zip = res.data[0].zip
            this.loaded = true
          })
      },
      updateProfile () {
        this.loaded = false
        let url = `member/profile/edit`
        this.$axios({
          method: 'POST',
          url: url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token,
            first: this.first,
            mi: this.middle,
            last: this.last,
            address: this.address,
            ahlid: this.ahlid,
            city: this.city,
            email: this.email,
            handle: this.handle,
            region: this.region,
            state: this.state,
            zip: this.zip,
            phone: this.phone,
            updates: this.updates,
            franchise: '',
            password: this.password,
            confirm: this.confirm
          }
        })
          .then((res) => {
            console.log(res.data.message)
            this.$emit('message',
              {
                showDialog: true,
                error: res.data.error,
                message: res.data.message
              })
            if (!res.data.error) {
              this.$emit('updateName', this.first, this.middle, this.last)
              this.$router.push('/')
            }
          })
          .catch(err => console.log(err))
      },
      setRegion () {
        this.$router.push('/account-edit/set-region')
      },
      linkToFacebook (id) {
        let data = {
          token: this.token,
          userid: id
        }
        this.$axios({
          method: 'POST',
          url: 'authenticate/fblink',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.$emit('message',
              {
                showDialog: true,
                error: false,
                message: `Your account has been linked to Facebook!`
              })
          })
          .catch((error) => {
            this.$emit('message',
              {
                showDialog: true,
                error: true,
                message: error.response.data.message
              })
          })
      },
      getFacebookId () {
        window.FB.getLoginStatus((response) => {
          if (response.status === 'connected') {
            this.linkToFacebook(response.authResponse.userID)
            console.log(response, 'logged in')
          } else {
            window.FB.login((res) => {
              this.linkToFacebook(response.authResponse.userID)
              console.log(res)
            })
          }
        })
      }
    }
  }
</script>
